var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTonometr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 82,
    viewBox: "0 0 127 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91819 25.9192C0.321567 33.104 13.0945 43.6816 14.0924 44.6795C32.254 56.4545 35.0481 51.2655 35.2476 50.2676C37.0438 44.879 27.8633 35.0998 20.2793 31.7069L15.2899 25.52C15.0903 25.3205 3.11565 19.9319 1.91819 25.9192Z",
    fill: "#303033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6605 45.8766C31.0554 44.0804 32.8516 43.0825 32.8516 43.0825L35.047 43.4817L34.4483 45.677C33.2508 46.4753 31.8538 47.2736 30.2571 48.4711L28.4609 47.8724L28.6605 45.8766Z",
    fill: "#535359"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2255 9.35378C45.2255 9.35378 45.4251 9.35378 45.2255 9.35378C45.4251 9.15421 45.8243 9.15421 46.0238 9.35378L53.0091 13.3453C61.1917 18.1352 67.5782 25.9187 67.5782 31.5069C67.5782 33.3031 66.9795 34.5006 65.782 35.0993L35.0471 52.8617L35.6458 49.2693L35.0471 45.2777L30.0576 38.4921L14.8897 28.1141L14.291 27.1162L45.2255 9.35378Z",
    fill: "#BCBEC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2255 9.35378C45.2255 9.35378 45.4251 9.35378 45.2255 9.35378C45.4251 9.15421 45.8243 9.15421 46.0238 9.35378L53.0091 13.3453C53.4082 13.5449 53.6078 13.7445 54.0069 13.9441L21.4758 32.7044L14.8897 28.1141L14.291 27.1162L45.2255 9.35378Z",
    fill: "#303033"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.65 4.56415C36.2445 2.96753 41.0343 3.56627 46.2234 6.55993L51.8115 9.75317C52.4103 10.1523 53.009 11.1502 53.009 11.7489C53.009 12.1481 52.8094 12.3477 52.6098 12.5473L21.6753 30.5092L19.2804 27.316L6.30786 22.9253L2.91504 22.3266L33.65 4.56415Z",
    fill: "#BCBEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2889 46.4753L22.0745 50.4669C30.2572 55.2567 36.6437 54.658 36.6437 49.2694C36.6437 43.8808 30.2572 35.8977 22.0745 31.1078L15.0893 27.1163C14.4906 26.7171 13.8918 27.1163 13.8918 27.715C13.8918 28.5133 14.4906 29.5112 15.0893 29.7108L22.0745 33.7023C29.2593 37.8935 34.2487 44.28 34.2487 47.6728C34.2487 50.866 29.2593 51.6643 22.0745 47.4732L15.2889 43.4816C8.30367 39.4901 3.11466 34.1015 3.11466 27.5154C3.11466 23.923 8.50325 22.9252 15.2889 26.9167L20.8771 30.11C21.4758 30.5091 22.0745 30.11 22.0745 29.5112C22.0745 28.7129 21.4758 27.715 20.8771 27.5154L15.2889 24.3222C7.50536 19.9315 0.719727 20.9294 0.719727 26.318C0.719727 35.6981 7.30579 41.885 15.2889 46.4753Z",
    fill: "#88898C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2568 48.0718C21.4753 54.0591 8.10365 65.2355 9.50069 72.0211C10.0994 75.2144 14.091 77.4097 21.2758 78.8067C33.2504 80.8025 37.8407 70.2249 42.431 58.849C45.8238 50.8659 49.2166 42.4836 55.8027 39.0908L57.1997 41.6853C51.6115 44.4794 48.6179 52.0634 45.2251 59.8469C40.8344 70.2249 36.0445 82 24.2694 82C23.2715 82 22.0741 82 20.8766 81.6008C12.4944 80.2038 7.70449 77.0105 6.7066 72.6198C5.70872 67.4308 9.89984 60.8448 19.0804 53.0612C22.4732 50.0676 26.0656 47.6727 28.6601 45.6769L30.2568 48.0718Z",
    fill: "#535359"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.056 22.3262L51.0146 41.8848L51.6134 48.6704C51.6134 50.4666 52.8108 52.0632 55.0062 53.4603L78.7559 67.2311C83.3462 69.8256 90.7306 69.8256 95.3209 67.2311L121.865 51.8636C124.06 50.4666 125.257 48.87 125.257 47.0738L126.056 22.3262Z",
    fill: "#D4D3D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7234 59.6474C90.131 63.4393 83.3454 64.4372 78.7551 61.8427L55.0053 48.0719C50.4151 45.4774 49.6168 40.0888 53.2091 36.2968L83.3454 4.3644C86.9378 0.572426 93.7234 -0.425462 98.3137 2.16905L122.063 15.9399C126.654 18.5344 127.452 23.923 123.86 27.715L93.7234 59.6474Z",
    fill: "#FFFCEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7158 47.8724C95.3208 50.4669 90.7306 51.0656 87.5373 49.2694L67.1804 37.4943C63.9872 35.6981 63.588 32.1057 65.983 29.5112L86.3399 7.95685C88.7348 5.36234 93.3251 4.76361 96.5183 6.55981L116.875 18.3349C120.068 20.1311 120.468 23.7235 118.073 26.318L97.7158 47.8724Z",
    fill: "#163FA8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3254 46.875L115.479 23.5245L94.7224 11.5498L72.5693 34.9004L93.3254 46.875Z",
    fill: "#E6E7E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 44.8788V43.2822L69.1758 46.2759V47.8725L71.9699 44.8788Z",
    fill: "#9C251F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1757 46.276L61.5918 41.8853V43.4819L69.1757 47.8726V46.276Z",
    fill: "#E31B25"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9708 43.2823L64.3869 38.8916L61.5928 41.8853L69.1767 46.276L71.9708 43.2823Z",
    fill: "#FF3F4A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7404 52.2626V50.666L81.9463 53.6597V55.2563L84.7404 52.2626Z",
    fill: "#939598"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9462 53.6597L74.3623 49.269V50.8657L81.9462 55.2564V53.6597Z",
    fill: "#D1D3D4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7403 50.6661L77.1564 46.2754L74.3623 49.2691L81.9462 53.6598L84.7403 50.6661Z",
    fill: "#F5F5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.102 23.5241L105.497 21.1291L104.698 20.73L102.503 23.1249L103.102 23.5241Z",
    fill: "#535359"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.905 19.1329L105.498 21.1287L106.096 20.53L102.504 18.5342L101.905 19.1329Z",
    fill: "#535359"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1123 22.1266L102.505 24.1223L103.104 23.5236L99.711 21.5278L99.1123 22.1266Z",
    fill: "#535359"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9229 23.9231L100.509 17.1374L99.7107 16.7383L93.3242 23.5239L93.9229 23.9231Z",
    fill: "#535359"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.308 26.5177L102.503 24.1228L101.905 23.7236L99.5098 26.1186L100.308 26.5177Z",
    fill: "#535359"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1191 25.3198L99.7115 27.3156L100.31 26.5173L96.7179 24.5215L96.1191 25.3198Z",
    fill: "#535359"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.69 26.7174L110.885 24.3225L110.287 23.9233L107.892 26.3183L108.69 26.7174Z",
    fill: "#535359"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.493 22.3268L110.886 24.3225L111.485 23.7238L108.092 21.728L107.493 22.3268Z",
    fill: "#535359"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.499 25.3204L108.091 27.3162L108.69 26.7175L105.098 24.7217L104.499 25.3204Z",
    fill: "#535359"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.697 29.7111L108.092 27.3161L107.294 26.917L105.099 29.3119L105.697 29.7111Z",
    fill: "#535359"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.706 28.5132L105.099 30.5089L105.698 29.7106L102.305 27.7148L101.706 28.5132Z",
    fill: "#535359"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1186 32.1056L97.314 29.7107L96.7152 29.3115L94.3203 31.7065L95.1186 32.1056Z",
    fill: "#535359"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9229 27.7153L97.3157 29.7111L97.9144 28.9128L94.5216 26.917L93.9229 27.7153Z",
    fill: "#535359"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9297 30.7091L94.5221 32.7049L95.1208 32.1061L91.5284 30.1104L90.9297 30.7091Z",
    fill: "#535359"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1271 35.0998L94.522 32.7048L93.7237 32.3057L91.5283 34.7006L92.1271 35.0998Z",
    fill: "#535359"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3266 30.5089L94.522 28.114L93.9233 27.7148L91.5283 30.1098L92.3266 30.5089Z",
    fill: "#535359"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3312 33.5031L91.7261 31.1081L90.9278 30.709L88.7324 33.1039L89.3312 33.5031Z",
    fill: "#535359"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1348 33.7027L91.5276 35.6985L92.1263 35.0998L88.7335 33.104L88.1348 33.7027Z",
    fill: "#535359"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1163 38.8914L102.904 32.904L102.305 32.5049L96.5176 38.4922L97.1163 38.8914Z",
    fill: "#535359"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5107 30.9087L102.904 32.9044L103.502 32.1061L100.109 30.1104L99.5107 30.9087Z",
    fill: "#535359"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5283 38.093L92.3245 39.0909L92.7237 38.6917L90.7279 37.6938L90.5283 38.093Z",
    fill: "#535359"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9326 39.6902L90.7288 40.8876L91.128 40.4885L89.1322 39.291L88.9326 39.6902Z",
    fill: "#535359"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M89.532 42.0845L90.7294 40.8871L90.3303 40.6875L89.1328 41.885L89.532 42.0845Z",
    fill: "#535359"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M89.532 39.4898L90.7294 38.2923L90.5299 38.0928L89.1328 39.2902L89.532 39.4898Z",
    fill: "#535359"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9343 41.2861L89.1318 39.889L88.9322 39.6895L87.5352 41.0865L87.9343 41.2861Z",
    fill: "#535359"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3359 41.286L89.1321 42.4835L89.5313 42.0843L87.5355 41.0864L87.3359 41.286Z",
    fill: "#535359"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1257 44.2799L95.319 40.8871L94.9198 40.6875L91.7266 44.0803L92.1257 44.2799Z",
    fill: "#535359"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5215 39.6898L95.3177 40.8873L95.7168 40.4881L93.7211 39.4902L93.5215 39.6898Z",
    fill: "#535359"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9328 15.3409L86.1408 13.1455L84.9434 14.343L88.7353 16.5383L89.9328 15.3409Z",
    fill: "#F3F3F3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9494 23.7237L78.1574 21.5283L76.96 22.7258L80.7519 25.1207L81.9494 23.7237Z",
    fill: "#F3F3F3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1603 29.91L70.7717 26.7168L69.5742 28.1138L74.9628 31.1075L76.1603 29.91Z",
    fill: "#F3F3F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonometr);
export default __webpack_public_path__ + "static/media/tonometr.43bddae9ff2c245802ce26350cf6aa4c.svg";
export { ForwardRef as ReactComponent };